// Le diff ligne à ligne de ce qu'un tour de l'agent a changé (plus longue sous-suite commune, après avoir retiré le
// début et la fin communs : les textes d'un chapitre ou d'un mémoire restent petits).

export type LigneDiff = { genre: "egal" | "ajout" | "retrait"; texte: string };

export function diffLignes(avant: string, apres: string): LigneDiff[] {
  const a = avant.split("\n");
  const b = apres.split("\n");
  let debut = 0;
  while (debut < a.length && debut < b.length && a[debut] === b[debut]) debut++;
  let fa = a.length;
  let fb = b.length;
  while (fa > debut && fb > debut && a[fa - 1] === b[fb - 1]) {
    fa--;
    fb--;
  }
  const x = a.slice(debut, fa);
  const y = b.slice(debut, fb);
  const t = Array.from({ length: x.length + 1 }, () => new Uint32Array(y.length + 1));
  for (let i = x.length - 1; i >= 0; i--) {
    for (let j = y.length - 1; j >= 0; j--) {
      t[i][j] = x[i] === y[j] ? t[i + 1][j + 1] + 1 : Math.max(t[i + 1][j], t[i][j + 1]);
    }
  }
  const out: LigneDiff[] = a.slice(0, debut).map((texte) => ({ genre: "egal", texte }));
  let i = 0;
  let j = 0;
  while (i < x.length && j < y.length) {
    if (x[i] === y[j]) {
      out.push({ genre: "egal", texte: x[i] });
      i++;
      j++;
    } else if (t[i + 1][j] >= t[i][j + 1]) {
      out.push({ genre: "retrait", texte: x[i++] });
    } else {
      out.push({ genre: "ajout", texte: y[j++] });
    }
  }
  while (i < x.length) out.push({ genre: "retrait", texte: x[i++] });
  while (j < y.length) out.push({ genre: "ajout", texte: y[j++] });
  for (const texte of a.slice(fa)) out.push({ genre: "egal", texte });
  return out;
}

// Les lignes inchangées loin de tout changement se replient en « … N lignes … ».
export type Morceau = LigneDiff | { genre: "replie"; n: number };

export function replier(lignes: LigneDiff[], contexte = 2): Morceau[] {
  const proches = new Set<number>();
  lignes.forEach((l, i) => {
    if (l.genre !== "egal") for (let k = i - contexte; k <= i + contexte; k++) proches.add(k);
  });
  const out: Morceau[] = [];
  let caches = 0;
  lignes.forEach((l, i) => {
    if (l.genre === "egal" && !proches.has(i)) {
      caches++;
      return;
    }
    if (caches) out.push({ genre: "replie", n: caches });
    caches = 0;
    out.push(l);
  });
  if (caches) out.push({ genre: "replie", n: caches });
  return out;
}

export function compter(lignes: LigneDiff[]): { ajouts: number; retraits: number } {
  return {
    ajouts: lignes.filter((l) => l.genre === "ajout").length,
    retraits: lignes.filter((l) => l.genre === "retrait").length,
  };
}
